export default __webpack_public_path__ + "static/media/saint_aubin.4ee4ad4a.jpg";